import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// ============================================================
// NUCLEAR PIXEL BLOCKER + DEDUPLICATOR
// Blocks pixel 528129859587075 at every level
// Ensures only ONE PageView fires for pixel 4350257011957917
// ============================================================
const BLOCKED_ID = '528129859587075';
const MY_ID = '4350257011957917';
// Track what we've already sent at the network level
const _sentEvents: Record<string, boolean> = {};
// Helper: should this URL be blocked or deduplicated?
function shouldBlockUrl(url: string): boolean {
  if (typeof url !== 'string') return false;
  // Block ALL requests for the unwanted pixel
  if (url.includes(BLOCKED_ID)) return true;
  // Deduplicate PageView for our pixel at the network level
  if (url.includes('facebook.com/tr') && url.includes(MY_ID) && url.includes('ev=PageView')) {
    const key = MY_ID + ':PageView';
    if (_sentEvents[key]) return true; // Already sent — block duplicate
    _sentEvents[key] = true;
  }
  return false;
}
// LAYER 1: Intercept fetch (modern fbevents.js uses fetch)
const _origFetch = window.fetch.bind(window);
(window as any).fetch = function (input: any, init?: any) {
  const url = typeof input === 'string' ? input : input?.url || '';
  if (shouldBlockUrl(url)) {
    return Promise.resolve(new Response('', {
      status: 200
    }));
  }
  return _origFetch(input, init);
};
// LAYER 2: Intercept sendBeacon
const _origBeacon = navigator.sendBeacon?.bind(navigator);
if (_origBeacon) {
  navigator.sendBeacon = function (url: string, data?: any) {
    if (shouldBlockUrl(url)) return true;
    return _origBeacon(url, data);
  };
}
// LAYER 3: Intercept XMLHttpRequest
const _origXHR = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function (method: string, url: string | URL, ...rest: any[]) {
  const urlStr = typeof url === 'string' ? url : url.toString();
  if (shouldBlockUrl(urlStr)) {
    return (_origXHR as any).call(this, method, 'about:blank', ...rest);
  }
  return (_origXHR as any).call(this, method, url, ...rest);
};
// LAYER 4: Intercept Image (tracking pixels use new Image().src)
const _OrigImage = window.Image;
(window as any).Image = function (w?: number, h?: number) {
  const img = new _OrigImage(w, h);
  const origSrcDesc = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src') || Object.getOwnPropertyDescriptor(Image.prototype, 'src');
  if (origSrcDesc && origSrcDesc.set) {
    const origSet = origSrcDesc.set;
    Object.defineProperty(img, 'src', {
      set(val: string) {
        if (shouldBlockUrl(val)) return; // Silently swallow
        origSet.call(this, val);
      },
      get() {
        return origSrcDesc.get ? origSrcDesc.get.call(this) : '';
      }
    });
  }
  return img;
} as any;
(window as any).Image.prototype = _OrigImage.prototype;
// LAYER 5: Remove existing platform scripts/images from DOM
document.querySelectorAll('script').forEach(s => {
  if (s.textContent?.includes(BLOCKED_ID)) s.remove();
});
document.querySelectorAll('img').forEach(img => {
  if (img.src?.includes(BLOCKED_ID)) img.remove();
});
// LAYER 6: MutationObserver — kill future injections
const obs = new MutationObserver(mutations => {
  for (const m of mutations) {
    for (const node of Array.from(m.addedNodes)) {
      if (node instanceof HTMLScriptElement && node.textContent?.includes(BLOCKED_ID)) {
        node.remove();
      } else if (node instanceof HTMLImageElement && node.src?.includes(BLOCKED_ID)) {
        node.remove();
      } else if (node instanceof Element) {
        node.querySelectorAll('script').forEach(s => {
          if (s.textContent?.includes(BLOCKED_ID)) s.remove();
        });
        node.querySelectorAll('img').forEach(i => {
          if (i.src?.includes(BLOCKED_ID)) i.remove();
        });
      }
    }
  }
});
obs.observe(document.documentElement, {
  childList: true,
  subtree: true
});
// LAYER 7: Nuke any existing fbq from platform
if ((window as any).fbq) {
  delete (window as any).fbq;
  delete (window as any)._fbq;
}
// ============================================================
// YOUR Meta Pixel — 4350257011957917 ONLY, ONE PageView
// ============================================================
;
(function (f: any, b: any, e: any, v: string, n?: any, t?: any, s?: any) {
  if (f.fbq) return;
  n = f.fbq = function () {
    const cmd = arguments[0];
    const arg = arguments[1];
    // Block init for unwanted pixel
    if (cmd === 'init' && arg === BLOCKED_ID) return;
    // Block duplicate PageView at fbq level too (belt + suspenders)
    if (cmd === 'track' && arg === 'PageView' && (window as any).__PV_DONE) return;
    if (cmd === 'track' && arg === 'PageView') (window as any).__PV_DONE = true;
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
(window as any).fbq('init', MY_ID);
(window as any).fbq('track', 'PageView');
// LAYER 8: Continuously strip blocked pixel if platform re-registers it
setInterval(() => {
  try {
    const w = window as any;
    if (w.fbq?.getState) {
      const state = w.fbq.getState();
      if (state?.pixels) {
        state.pixels = state.pixels.filter((p: any) => p.id !== BLOCKED_ID);
      }
    }
  } catch (e) {}
}, 500);
// ============================================================
render(<App data-id="element-248" />, document.getElementById('root'));